import React, { useState } from 'react';
import _ from 'lodash';

import { Modal, ModalHeader, ModalBody, ModalFooter } from 'design-system/Modal';
import { Button } from 'design-system/Form';
import Select from 'design-system/SelectInput';
import { ProjectDisableReason, ProjectDisableReasonFriendlyName } from '@scale/shared/defaults';

interface IProjectDisableReasonPickerProps {
  show: boolean;
  disabled: boolean;
  onClose: () => void;
  onConfirm: (r: ProjectDisableReason) => void;
}

const ProjectDisableReasonPicker = ({
  show,
  disabled,
  onClose,
  onConfirm,
}: IProjectDisableReasonPickerProps) => {
  const [reason, setReason] = useState<ProjectDisableReason | null>(null);

  return (
    <Modal isOpen={show}>
      <ModalHeader>Pick the project disable reason</ModalHeader>
      <ModalBody>
        <div style={{ textAlign: 'center' }}>
          <Select
            disabled={disabled}
            onChange={e => setReason(e.target.value as ProjectDisableReason)}
          >
            <option selected={true} disabled={true} value={''} key={0}>
              Select a reason
            </option>
            {_.values(ProjectDisableReason).map(r => (
              <option value={r} key={r}>
                {ProjectDisableReasonFriendlyName[r]}
              </option>
            ))}
          </Select>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          style={{ margin: '0 10px' }}
          disabled={disabled || !reason}
          type="primary"
          onClick={() => onConfirm(reason!)}
        >
          Confirm
        </Button>
        <Button
          style={{ margin: '0 10px' }}
          disabled={disabled}
          type="secondary"
          onClick={() => onClose()}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export { ProjectDisableReasonPicker };
